type AttributeValidationResult = {
  isDisabled: boolean;
  reason?: string;
};

/**
 * Check if an attribute is being used in any category mapping
 * An attribute is considered "in use" if it appears in any category's attribute pairs
 */
export const validateAttributeToggle = (
  attributeName: string,
  categoryMappings: MappingCategory[]
): AttributeValidationResult => {
  // Check if this attribute appears in any category mapping
  const isUsedInCategoryMapping = categoryMappings.some(category => 
    category.attribute && 
    category.attribute.length > 0 && 
    category.attribute.some(pair => 
      pair.attribute && 
      pair.attribute.trim().toLowerCase() === attributeName.trim().toLowerCase()
    )
  );

  if (isUsedInCategoryMapping) {
    return {
      isDisabled: true,
      reason: 'This attribute is being used in category mapping and cannot be disabled',
    };
  }

  return {
    isDisabled: false,
  };
};

/**
 * Check if an attribute-value pair is being used in any category mapping
 * A pair is considered "in use" if both the attribute and attribute value match in any category
 */
export const validateAttributeValueToggle = (
  attributeName: string,
  attributeValue: string,
  categoryMappings: MappingCategory[]
): AttributeValidationResult => {
  // Check if this attribute-value pair appears in any category mapping
  const isUsedInCategoryMapping = categoryMappings.some(category => 
    category.attribute && 
    category.attribute.length > 0 && 
    category.attribute.some(pair => {
      const matchesAttribute = pair.attribute && 
        pair.attribute.trim().toLowerCase() === attributeName.trim().toLowerCase();
      const matchesValue = pair.attributeValue && 
        pair.attributeValue.trim().toLowerCase() === attributeValue.trim().toLowerCase();
      
      return matchesAttribute && matchesValue;
    })
  );

  if (isUsedInCategoryMapping) {
    return {
      isDisabled: true,
      reason: 'This attribute value is being used in category mapping and cannot be disabled',
    };
  }

  return {
    isDisabled: false,
  };
};
